module.exports = __webpack_public_path__ + "static/TFF_Barnowl-7babbb9e38a5019bb04e6e709f45d2be.jpg";